import markSvg from '@/assets/brand/tts-mark.svg?raw';
import stackSvg from '@/assets/brand/tts-stack.svg?raw';
import stickerSvg from '@/assets/brand/tts-sticker.svg?raw';

/**
 * The TTS wordmark, inlined from the owner's redrawn vectors (brand/*.svg, copied into
 * client/src/assets/brand). Never retype TTS in a font. The small circled C is left out on
 * purpose (BRAND.md).
 *
 * - sticker: white letters, ink outline, grape shadow. The everyday logo on colored grounds.
 * - stack: lavender letters with the sky, mint, butter, peach stack. Gate, splash, empty states.
 * - mark: one color, follows `currentColor`.
 */
const SVG = { sticker: stickerSvg, stack: stackSvg, mark: markSvg } as const;

export interface WordmarkProps {
  variant?: keyof typeof SVG;
  /** CSS width; the height follows the artwork's aspect ratio. */
  width?: number | string;
  className?: string;
  label?: string;
}

export function Wordmark({ variant = 'sticker', width = 120, className, label = 'TTS' }: WordmarkProps) {
  return (
    <span
      role="img"
      aria-label={label}
      className={`tts-wordmark inline-block leading-none [&>svg]:block [&>svg]:h-auto [&>svg]:w-full ${className ?? ''}`}
      style={{ width }}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: our own brand SVGs from the repo, inlined at build time
      dangerouslySetInnerHTML={{ __html: SVG[variant].replace(/role="img" aria-label="TTS"/, 'aria-hidden="true"') }}
    />
  );
}
